exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".changelog {\n  padding: 20px; }\n  .changelog .content-wrapper {\n    max-width: 800px;\n    margin: 0 auto; }\n  .changelog .content h1 {\n    font-size: 24px;\n    margin-top: 0;\n    margin-bottom: 20px; }\n  .changelog .content h2 {\n    font-size: 20px;\n    margin-top: 0;\n    margin-bottom: 20px; }\n  .changelog .content h3 {\n    font-size: 18px;\n    margin-top: 0;\n    margin-bottom: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/app/node_modules"]}!./src/app/components/changelog/changelog.scss
// module id = 1582
// module chunks = 0